module.exports = __webpack_public_path__ + "media/images/Icon_Instagram-3f92ac3daf6dbdc548f378f37c8271b8.svg";